import React, { createContext, useContext, useReducer } from "react";

import { compareReducer } from "./CompareReducer";
import type {
  CompareAction,
  CompareState,
} from "@/context/Compare/types";
import { initialState } from "@/context/Compare/types";

const CompareContext = createContext<{
  state: CompareState;
  dispatch: React.Dispatch<CompareAction>;
}>({
  state: initialState,
  dispatch: () => null,
});

export const CompareProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(compareReducer, initialState);

  return (
    <CompareContext.Provider value={{ state, dispatch }}>
      {children}
    </CompareContext.Provider>
  );
};

export const useCompareContext = () => {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error(
      "useCompareContext must be used within a CompareProvider"
    );
  }
  return context;
};
